export enum CustomDOMEvents {
  ON_401 = 'on401',
  ON_STRIPE_WALLET_BUTTON_CLICK = 'stripe-wallet-button-click',
}
